import { HttpService } from '@/shared/services'
import Approver from '../models/Approver'
import AssignApprover from '../models/AssignApprover'
import CreateBulkValidationInputDto from './interfaces/CreateBulkValidationInputDto'
import useNotifications from '@/store/notification'

const http = new HttpService()

export const getApproversByCompanyId = async (companyId: string) => {
  const response = await http.get<Approver[]>(`/approver/${companyId}`)
  return response.data
}

export const assignApprovers = async (asignations: AssignApprover[]) => {
  const response = await http.post<{ assignments: AssignApprover[] }, string>(
    `/employee/supervisor/assign`,
    {
      assignments: asignations,
    }
  )
  return response.data
}

export const validateBulkAssignation = async (
  dto: CreateBulkValidationInputDto
) => {
  const formData = new FormData()
  formData.append('file', dto.file)
  try {
    const response = await http.post<FormData, Blob>(
      `/approver/validate-bulk-supervisor-assignment?companyId=${dto.companyId}&payrollId=${dto.payrollId}`,
      formData,
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (response.data.size <= 2) {
      return null
    }

    let receivedBytes = 0
    const reader = response.data.stream().getReader()
    const chunks = []

    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      chunks.push(value)
      receivedBytes += value.byteLength
      console.log(`Received ${receivedBytes} bytes`)
    }

    const blob = new Blob(chunks, { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url

    const fileName = 'assignment-error-report.csv'
    link.setAttribute('download', fileName)

    // Append to DOM and trigger download
    document.body.appendChild(link)
    link.click()

    // Cleanup
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    return 'OK'
  } catch (err: Error | any) {
    const notificationStore = useNotifications()

    // Check if the error response contains a blob with a JSON message inside.
    if (err.response && err.response.data instanceof Blob) {
      const errorJson = await err.response.data.text()
      const errorObj = JSON.parse(errorJson)
      notificationStore.addInfoNotification({
        detail: errorObj.status,
        severity: 'info',
        summary: errorObj.message || 'Error during file processing',
      })
    }
  }
}
